import { User } from "../../store/store";
import moment from "moment-timezone";
import { Component } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { ZTillReceipt } from "@/types/prisma.types";
import { Income } from "./TicketZEditionBase";
import { ComponentBase } from "../ComponentBase";

@Component
export class TicketZBase extends ComponentBase {
    @Prop({ default: "Router" }) mode: string;
    @Prop({ default: false }) Mode: boolean;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: null }) inZTillReceipt: ZTillReceipt;

    creationMode: string = "creation";

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get selectedCompany() {
        return this.$store.getters.getCompany(this.companyId);
    }

    freeAmountAccountableAccount = "623410";

    period = "UNKNOWN";

    /* --- TVA --- */

    incomes = [];

    defaultCommission: Income = {
        vatRate: 20,
        vatType: null,
        netAmount: 0.0,
        vatAmount: 0.0,
        grossAmount: 0.0,
        document: null,
        accountableAccount: null,
        freeAmount: 0.0,
    };

    commission: Income = {
        vatRate: 20,
        vatType: null,
        netAmount: 0.0,
        vatAmount: 0.0,
        grossAmount: 0.0,
        document: null,
        accountableAccount: null,
        freeAmount: 0.0,
    };

    additionalAmounts: Array<{ name: string; amountSigned: number }> = [];

    get paidAmount() {
        let paidAmount = this.totalGrossAmount;
        for (const income of this.incomes) {
            if (income.freeAmount) {
                paidAmount -= income.freeAmount;
            }
        }
        if (this.commission && this.commission.grossAmount) {
            paidAmount -= this.commission.grossAmount;
        }
        for (const additionalAmount of this.additionalAmounts) {
            if (additionalAmount.amountSigned) {
                paidAmount -= additionalAmount.amountSigned;
            }
        }
        return paidAmount;
    }

    get freeAmount() {
        let freeAmount = 0.0;
        for (const income of this.incomes) {
            if (income.freeAmount) {
                freeAmount += income.freeAmount;
            }
        }
        return freeAmount;
    }

    get totalNetAmount() {
        let total = 0;
        for (const vatItem of this.incomes) {
            if (this.isItemValid(vatItem)) {
                total += Number(vatItem.netAmount);
            }
        }
        // if (this.commission && this.commission.netAmount) {
        //     total -= this.commission.netAmount
        // }
        return total;
    }

    get totalVatAmount() {
        let total = 0;
        for (const vatItem of this.incomes) {
            if (this.isItemValid(vatItem)) {
                total += Number(vatItem.vatAmount);
            }
        }
        // if (this.commission && this.commission.vatAmount) {
        //     total -= this.commission.vatAmount
        // }
        return total;
    }

    get totalGrossAmount() {
        let total = 0;
        for (const vatItem of this.incomes) {
            if (this.isItemValid(vatItem)) {
                total += Number(vatItem.grossAmount);
            }
        }
        // if (this.commission && this.commission.grossAmount) {
        //     total -= this.commission.grossAmount
        // }
        return total;
    }

    isItemValid(item) {
        if (!item.accountableAccount) return false;
        if (item.vatRate == undefined) return false;
        if (!item.netAmount) return false;
        // if (!item.vatAmount && !item.vatRate) return false;
        if (!item.grossAmount) return false;
        return true;
    }

    getPeriod(period) {
        if (period) {
            switch (period) {
                case "AM":
                    return "Matin";
                case "PM":
                    return "Après-midi";
                case "DA":
                    return "Journée";
                case "WE":
                    return "Semaine";
                case "MO":
                    return "Mois";
                case "UNKNOWN":
                    return "Période Inconnue";
            }
        }
        return "Période inconnue";
    }

    /**
     * Obtains the date of a zTillReceipt and formats it.
     * @param zTillReceipt an optional ZTillReceipt from prisma. If set to falsy, this method will use the input zTillReceipt
     * @returns
     */
    getDate(zTillReceipt: ZTillReceipt = undefined) {
        if (!zTillReceipt) {
            if (this.inZTillReceipt.period === "MO") {
                return moment(this.inZTillReceipt.date).locale("fr").format("MMM YYYY");
            }
            return moment(this.inZTillReceipt.date).locale("fr").format("DD MMM YYYY");
        } else {
            if (zTillReceipt.period === "MO") {
                return moment(zTillReceipt.date).locale("fr").format("MMM YYYY");
            }
            return moment(zTillReceipt.date).locale("fr").format("DD MMM YYYY");
        }
    }
}
